import React from 'react';
export function PricingSection() {
  return <section className="space-y-8 text-lg leading-relaxed text-stone-800 my-12" data-id="element-129">
      <div className="space-y-4" data-id="element-130">
        <h3 className="text-xl sm:text-2xl font-bold text-stone-900 font-serif leading-snug" data-id="element-131">
          7 - Avedis, a formula backed by 60+ clinical studies with ingredients
          sourced from New Zealand sounds like something that should cost a
          fortune. So why is it so mind-blowingly affordable?
        </h3>
        <img src="https://cdn.magicpatterns.com/uploads/9zEeVHQ6ixwxnhoQ5JSpyj/hf_20260410_032230_ea014bf3-bc4e-4280-8d3b-ce75727c0b1a_(1).png" alt="Not available in retail stores or online marketplaces" className="w-full rounded-md" data-id="element-132" />
        <p data-id="element-133">
          Avedis: That's an easy one. Instead of pricing ClearGuard Pro at what
          the "marketing experts" recommended, I simply priced it at what would
          actually get it into the hands of people who need it most.
        </p>
        <p data-id="element-134">
          Because at the end of the day, helping others smile without having to
          think about it will always matter more to me than the money.
        </p>
        <p data-id="element-135">And that applies to anyone reading this as well…</p>
        <p data-id="element-136">
          Which means today, on this page only, you won't pay anywhere near what
          this formula is worth.
        </p>
        <p className="font-[700]" data-id="element-137">
          In fact, this page is quite literally the only place you can find
          ClearGuard Pro currently.
        </p>
        <p data-id="element-138">
          Why? Because when we initially explored going into retailers and even
          Amazon, they made it very clear - their shelf fees, their margins, and
          their middlemen would have forced us to charge you nearly three times
          the price.
        </p>
        <p className="font-[700]" data-id="element-139">
          One major retailer you probably shopped at this week told us point
          blank:
        </p>
        <p className="pl-6 border-l-4 border-stone-300 italic text-stone-600 my-6 text-[24px] font-[400]" data-id="element-140">
          "At minimum, you'd have to price this at $197 for a single bottle…"
        </p>
        <p data-id="element-141">Can you believe that? My jaw dropped when I heard that number…</p>
        <p data-id="element-142">
          And while it made sense considering the power of this formula, I
          didn't develop ClearGuard Pro to sit on a shelf in a store that
          profits from people's dental problems.
        </p>
        <p data-id="element-143">
          So I walked away from every retailer and every platform that would
          have stood between this formula and anyone reading this.
        </p>
        <p data-id="element-144">
          Because instead of charging you $197 for a single bottle - which every
          retailer told us was the "right" price - I made a different decision.
        </p>
        <p data-id="element-145">
          Since we ship directly from our lab in small batches and don't pay for
          TV ads, we can pass every cent of those 'middleman' savings directly
          to you.
        </p>
        <p data-id="element-146">
          And that's before I tell you what else I'm including for anyone who
          orders today.
        </p>
      </div>

      <div className="bg-[#2D6A4F] text-white p-8 sm:p-10 rounded-sm my-12 text-center space-y-6 shadow-md" data-id="element-147">
        <h3 className="text-2xl sm:text-3xl font-bold font-serif leading-tight" data-id="element-148">
          Today, on this page only, instead of paying $197 for a single
          bottle...
        </h3>
        <p className="text-xl sm:text-2xl font-serif leading-snug font-[700] text-[#FFFFFF]" data-id="element-149">
          You're going to get a full three month supply - 90 full days - of
          ClearGuard Pro for just $147.
        </p>
        <p className="text-xl font-[700] text-[#FFFFFF]" data-id="element-150">
          That's just $49 a bottle... or $1.63 a day...
        </p>
      </div>

      <div className="space-y-4" data-id="element-151">
        <p data-id="element-152">
          For three full months of oral restoration - right from the comfort of
          your home.
        </p>
        <p data-id="element-153">Less than a single stick of gum from the gas station…</p>
        <p data-id="element-154">
          Less than what most people spend on toothpaste and mouthwash every
          year…
        </p>
        <p data-id="element-155">
          A fraction of what one cavity filling will cost you if this problem
          goes untreated…
        </p>
        <p data-id="element-156">And retailers wanted $197 for one bottle…</p>
        <p className="font-[700]" data-id="element-157">
          Think about it: That's at least $444 that stays in your bank
          account—nearly enough to cover a month of groceries or a well-deserved
          weekend getaway—simply because we decided to bypass the retailers and
          go straight to you.
        </p>
        <p data-id="element-158">
          But that's not all, because there's one more thing I want to do for
          you today…
        </p>
        <p data-id="element-159">
          If you've read this far — I already know you're someone who doesn't
          give up.
        </p>
        <p data-id="element-160">
          You've tried things and you've been let down… Yet, you're still here,
          still looking for a real answer.
        </p>
        <p data-id="element-161">
          This tells me everything I need to know about how serious you are
          about fixing this.
        </p>
        <p data-id="element-162">
          And I also know something else - that this problem didn't happen
          overnight…
        </p>
        <p data-id="element-163">Which means real microbiome restoration won't either…</p>
        <p data-id="element-164">
          And the last thing I want is for you to run out of ClearGuard Pro
          right when you finally start falling asleep at night without your
          teeth being the last thing on your mind.
        </p>
        <div className="bg-[#2D6A4F] text-white p-8 sm:p-10 rounded-sm my-8 text-center space-y-6 shadow-md" data-id="element-165">
          <p className="text-xl sm:text-2xl font-serif leading-snug font-[700] text-[#FFFFFF]" data-id="element-166">
            So today, if you choose the three month supply at checkout, I'm
            buying two months of ClearGuard Pro for you out of my own pocket.
          </p>
        </div>
        <p data-id="element-167">
          That's right. Even though my accountant won't like it, I'll personally
          cover the cost of two additional bottles myself.
        </p>
        <p data-id="element-168">
          Because if you give this protocol the time it needs to actually work —
          I am that confident you're going to feel the difference in your mouth,
          and hear it from your dentist at your next checkup.
        </p>
        <p data-id="element-169">
          Five full months of ClearGuard Pro. You pay for three, and I cover the
          rest. That's my commitment to you.
        </p>
        <p data-id="element-170">
          And while there is no catch, I can only cover the cost of these extra
          bottles as long as this current shipment lasts.
        </p>
        <p data-id="element-171">
          Once the 'Glendale batch' is gone, I have to go back to my standard
          3-bottle pricing.
        </p>
        <p data-id="element-172">Sounds good? Perfect.</p>
        <p data-id="element-173">
          Now before you go on and secure your 90 month supply along with the
          additional 2 bottles I will be covering myself…
        </p>
        <h3 className="text-xl sm:text-2xl font-bold text-stone-900 font-serif leading-snug" data-id="element-174">
          You may be wondering - "Will I get my money back if it won't work for
          me?"
        </h3>
        <img src="https://cdn.magicpatterns.com/uploads/5jKKqBJax1vNtarvserC7H/Untitled_design_(13)_(1).png" alt="ClearGuard Pro bottles with 90 day money back guarantee badge" className="w-full rounded-md" data-id="element-175" />
        <p data-id="element-176">
          Here's the honest truth: in the years I've been giving these to my own
          patients, not a single one has ever walked back into my office and
          told me they didn't work.
        </p>
        <p data-id="element-177">
          It didn't matter if they had been struggling with cavities their
          entire life…
        </p>
        <p data-id="element-178">It didn't matter if their gums had been bleeding for years…</p>
        <p data-id="element-179">
          It didn't matter if three different dentists had already told them
          their situation was beyond fixing…
        </p>
        <p className="font-[700]" data-id="element-180">
          Every single person reported something positive. Every. Single. One
        </p>
        <p data-id="element-181">
          And now that we're making ClearGuard Pro available online for the
          first time — I want to extend that same confidence to you.
        </p>
        <p className="font-[700]" data-id="element-182">
          So here's my challenge to you: try it for a full 90 days.
        </p>
        <p data-id="element-183">Give the ClearGuard Protocol the time it actually needs to work.</p>
        <p data-id="element-184">
          Let your enamel rebuild. Let your mouth's biological guard
          reestablish.
        </p>
        <p data-id="element-185">
          And after that, go to your next dentist appointment and see what they
          say.
        </p>
        <p data-id="element-186">
          If after 90 full days you want to be the first person in the history
          of this formula to tell me it didn't work for you…
        </p>
        <p className="font-[700]" data-id="element-187">
          Simply email us and we will refund every single cent. No questions. No
          hassle. No hard feelings.
        </p>
        <p className="font-[700]" data-id="element-188">I'm that confident.</p>
        <p data-id="element-189">
          The only question is: are you willing to find out what your mouth is
          actually capable of?
        </p>
        <p className="font-[700]" data-id="element-190">
          Because the way I see it, you have nothing to lose. And a smile you
          don't have to think about to gain.
        </p>
        <p data-id="element-191">
          If you're ready to experience what the people of Glendale have been
          raving about — and what's now available outside of that small
          community for the very first time — simply click the button below.
        </p>
      </div>

      <div className="bg-[#2D6A4F] text-white p-8 sm:p-12 rounded-sm my-12 text-center space-y-6 shadow-md" data-id="element-192">
        <h3 className="text-2xl sm:text-3xl font-bold font-serif leading-tight" data-id="element-193">
          Claim Your 3 Month Supply + 2 Free Bottles
        </h3>
        <p className="text-lg sm:text-xl font-serif leading-snug text-white/90" data-id="element-194">
          5 bottles of ClearGuard Pro for the price of 3 — only while the
          Glendale batch lasts.
        </p>
        <a href="https://clearguardnutrition.com/products/dental-oral-health-chewables?variant=48949171650812" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#F4A261] hover:bg-[#E68A3A] text-stone-900 font-bold text-lg sm:text-xl px-10 py-4 rounded-md shadow-lg transition-colors duration-200 font-serif" data-id="element-195">
          Check Availability →
        </a>
        <p className="text-sm text-white/70" data-id="element-196">
          90-Day Money Back Guarantee · Free Shipping · Limited Supply
        </p>
      </div>

      <div className="mt-16 pt-10 border-t border-stone-200 text-center space-y-4" data-id="element-197">
        <h4 className="text-xl sm:text-2xl font-bold text-stone-400 tracking-widest uppercase" data-id="element-198">
          Scientific References
        </h4>
        <ul className="space-y-2 text-stone-400 text-sm sm:text-base" data-id="element-199">
          <li data-id="element-200">pmc.ncbi.nlm.nih.gov/articles/PMC9955010/</li>
          <li data-id="element-201">clinicaltrials.gov/study/NCT02444182</li>
          <li data-id="element-202">pmc.ncbi.nlm.nih.gov/articles/PMC9131035/</li>
          <li data-id="element-203">pmc.ncbi.nlm.nih.gov/articles/PMC4232036/</li>
          <li data-id="element-204">pmc.ncbi.nlm.nih.gov/articles/PMC12466288/</li>
          <li data-id="element-205">pmc.ncbi.nlm.nih.gov/articles/PMC6926775/</li>
          <li data-id="element-206">pmc.ncbi.nlm.nih.gov/articles/PMC4127827/</li>
          <li data-id="element-207">pmc.ncbi.nlm.nih.gov/articles/PMC12705589/</li>
          <li data-id="element-208">pmc.ncbi.nlm.nih.gov/articles/PMC9668099/</li>
          <li data-id="element-209">pmc.ncbi.nlm.nih.gov/articles/PMC10187049/</li>
          <li data-id="element-210">pmc.ncbi.nlm.nih.gov/articles/PMC10421449/</li>
          <li data-id="element-211">pmc.ncbi.nlm.nih.gov/articles/PMC5851198/</li>
          <li data-id="element-212">pmc.ncbi.nlm.nih.gov/articles/PMC5824418/</li>
        </ul>
      </div>

      <footer className="bg-[#1B2838] text-stone-400 text-center py-10 px-6 mt-16 rounded-sm space-y-6" data-id="element-213">
        <p className="text-sm sm:text-base leading-relaxed" data-id="element-214">
          This is an advertorial and not an actual news article, blog, or
          consumer protection update.
        </p>
        <p className="text-sm sm:text-base leading-relaxed" data-id="element-215">
          The statements made on this website have not been evaluated by the
          Food and Drug Administration. This product is not intended to
          diagnose, treat, cure, or prevent any disease.
        </p>
        <hr className="border-stone-600 mx-auto max-w-2xl" data-id="element-216" />
        <p className="text-sm text-stone-500" data-id="element-217">
          © 2026 ClearGuard Pro. All rights reserved.
        </p>
      </footer>
    </section>;
}